import BaseButtonBuilder from '../Buttons'
import { BaseButton } from '../Buttons/types'

export interface MessageButtons {
  buttons: Array<Array<BaseButton>>
}

export type AvailableButtonsTypes = Array<ButtonBuildersGroups | BaseButtonBuilder>

export class ButtonBuildersGroups {
  titleKey: string
  items: Array<BaseButtonBuilder>

  constructor(title: string, items: Array<BaseButtonBuilder>) {
    this.titleKey = title
    this.items = items
  }
}
